import React from 'react'

export const Invoices = () => {
  return (
    <div>Invoices building soon......</div>
  )
}
